import React from 'react'
import RequireAuth from '@Components/Utility/RequireAuth'
import Navigation from '@App/navigation'
import RegistrationQuestionnaire from '@Scenes/RightsholderRegistrationLayout/RegistrationQuestionnaire'
import { Navigate } from 'react-router'
import RightsholderRegistrationForm from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm'
import RightsholderRegistrationLayout from '@Scenes/RightsholderRegistrationLayout'
import { FORM_SEGMENT, QUESTIONNAIRE_ROUTE, REGISTRATION_MEMBER_ROUTE } from '@App/navigation/route'

const createRegistrationMemberRoutesV2 = () => ({
    path: REGISTRATION_MEMBER_ROUTE,
    element: (
        <RequireAuth>
            <RightsholderRegistrationLayout />
        </RequireAuth>
    ),
    children: [
        {
            path: FORM_SEGMENT,
            element: <RightsholderRegistrationForm />,
        },
        {
            path: QUESTIONNAIRE_ROUTE,
            element: <RegistrationQuestionnaire />,
        },
        {
            path: '',
            element: <Navigate to={Navigation.registrationRightsholder.form()} replace />,
        },
    ],
})

export default createRegistrationMemberRoutesV2
